var map = {
	"./": 89,
	"./App": 120,
	"./App.js": 120,
	"./assets/images/amenities/Dollhouse_level_1.jpg": 296,
	"./assets/images/amenities/Dollhouse_level_2.jpg": 297,
	"./assets/images/amenities/Dollhouse_level_30.jpg": 298,
	"./assets/images/amenities/co-working.jpg": 299,
	"./assets/images/amenities/dining_rendering.jpg": 300,
	"./assets/images/amenities/gallery_arrow_left.svg": 301,
	"./assets/images/amenities/gallery_arrow_right.svg": 302,
	"./assets/images/amenities/gym.jpg": 303,
	"./assets/images/amenities/hero_rendering.jpg": 304,
	"./assets/images/amenities/lobby_rendering.jpg": 305,
	"./assets/images/amenities/mobile_hero_rendering.jpg": 306,
	"./assets/images/amenities/outdoor_lounge_rendering.jpg": 307,
	"./assets/images/amenities/rooftop_rendering.jpg": 308,
	"./assets/images/amenities/social_lounge.jpg": 309,
	"./assets/images/ascent_hero_rendering_menu.jpg": 287,
	"./assets/images/floorplans/building/Building.jpg": 310,
	"./assets/images/floorplans/building/Level_Shapes.svg": 681,
	"./assets/images/floorplans/card_badge_shape.png": 311,
	"./assets/images/floorplans/card_badge_shape.svg": 682,
	"./assets/images/floorplans/filter_badge_shape.png": 683,
	"./assets/images/floorplans/filter_badge_shape.svg": 312,
	"./assets/images/floorplans/mobile_card_badge_shape.png": 313,
	"./assets/images/floorplans/mobile_card_badge_shape.svg": 684,
	"./assets/images/floorplans/north/icon_north.svg": 202,
	"./assets/images/floorplans/north/icon_north@1x.png": 685,
	"./assets/images/floorplans/plans/a1.png": 314,
	"./assets/images/floorplans/plans/a2.png": 315,
	"./assets/images/floorplans/plans/a3.png": 316,
	"./assets/images/floorplans/plans/a4.png": 317,
	"./assets/images/floorplans/plans/b1.png": 318,
	"./assets/images/floorplans/plans/b2.png": 319,
	"./assets/images/floorplans/plans/b3.png": 320,
	"./assets/images/floorplans/plans/b5.png": 321,
	"./assets/images/floorplans/plans/b6.png": 322,
	"./assets/images/floorplans/plans/c1.png": 323,
	"./assets/images/floorplans/plans/c2.png": 324,
	"./assets/images/floorplans/plans/c3.png": 325,
	"./assets/images/floorplans/plans/d1.png": 326,
	"./assets/images/floorplans/plans/d2.png": 327,
	"./assets/images/floorplans/plans/d3.png": 328,
	"./assets/images/floorplans/plans/e1.png": 329,
	"./assets/images/floorplans/plans/e2.png": 330,
	"./assets/images/floorplans/plans/e3.png": 331,
	"./assets/images/floorplans/plans/f.png": 332,
	"./assets/images/floorplans/plans/g.png": 333,
	"./assets/images/floorplans/plans/th1.png": 334,
	"./assets/images/floorplans/plans/th2.png": 335,
	"./assets/images/floorplans/plans/th3.png": 336,
	"./assets/images/floorplans/plans/th4.png": 337,
	"./assets/images/floorplans/thumbs/a1_level_7.png": 338,
	"./assets/images/floorplans/thumbs/a1_levels_3-6.png": 339,
	"./assets/images/floorplans/thumbs/a1_levels_8-29.png": 340,
	"./assets/images/floorplans/thumbs/a2_levels_3-6.png": 341,
	"./assets/images/floorplans/thumbs/a3_levels_20-29.png": 342,
	"./assets/images/floorplans/thumbs/a4_level_7.png": 343,
	"./assets/images/floorplans/thumbs/a4_levels_8-19.png": 344,
	"./assets/images/floorplans/thumbs/b1_levels_3-6.png": 345,
	"./assets/images/floorplans/thumbs/b2_levels_3-6.png": 346,
	"./assets/images/floorplans/thumbs/b3_level_7.png": 347,
	"./assets/images/floorplans/thumbs/b3_levels_8-29.png": 348,
	"./assets/images/floorplans/thumbs/b5_levels_3-6.png": 349,
	"./assets/images/floorplans/thumbs/b6_level_7.png": 350,
	"./assets/images/floorplans/thumbs/b6_levels_8-29.png": 351,
	"./assets/images/floorplans/thumbs/c1_level_7.png": 352,
	"./assets/images/floorplans/thumbs/c1_levels_3-6.png": 353,
	"./assets/images/floorplans/thumbs/c1_levels_8-29.png": 354,
	"./assets/images/floorplans/thumbs/c2_level_7.png": 355,
	"./assets/images/floorplans/thumbs/c2_levels_8-29.png": 356,
	"./assets/images/floorplans/thumbs/c3_levels_3-6.png": 357,
	"./assets/images/floorplans/thumbs/d1_levels_3-6.png": 358,
	"./assets/images/floorplans/thumbs/d2_level_7.png": 359,
	"./assets/images/floorplans/thumbs/d2_levels_8-29.png": 360,
	"./assets/images/floorplans/thumbs/d3_level_30.png": 361,
	"./assets/images/floorplans/thumbs/d3_level_31.png": 362,
	"./assets/images/floorplans/thumbs/e1_level_7.png": 363,
	"./assets/images/floorplans/thumbs/e1_levels_8-29.png": 364,
	"./assets/images/floorplans/thumbs/e2_level_30.png": 365,
	"./assets/images/floorplans/thumbs/e2_level_31.png": 366,
	"./assets/images/floorplans/thumbs/e3_level_30.png": 367,
	"./assets/images/floorplans/thumbs/e3_level_31.png": 368,
	"./assets/images/floorplans/thumbs/f_levels_3-6.png": 369,
	"./assets/images/floorplans/thumbs/g_levels_3-6.png": 370,
	"./assets/images/floorplans/thumbs/th1_level_1.png": 371,
	"./assets/images/floorplans/thumbs/th1_level_2.png": 372,
	"./assets/images/floorplans/thumbs/th2_level_1.png": 373,
	"./assets/images/floorplans/thumbs/th2_level_2.png": 374,
	"./assets/images/floorplans/thumbs/th3_level_1.png": 375,
	"./assets/images/floorplans/thumbs/th3_level_2.png": 376,
	"./assets/images/floorplans/thumbs/th4_level_1.png": 377,
	"./assets/images/floorplans/thumbs/th4_level_2.png": 378,
	"./assets/images/footer/footer_map.png": 686,
	"./assets/images/footer/footer_map.svg": 687,
	"./assets/images/footer/sub-footer_image.jpg": 291,
	"./assets/images/footer/sub-footer_image_mobile.jpg": 290,
	"./assets/images/footer/yellow_shape.svg": 292,
	"./assets/images/home/amenities_rendering.jpg": 379,
	"./assets/images/home/hero_rendering.jpg": 380,
	"./assets/images/home/interiors_rendering.jpg": 381,
	"./assets/images/home/mobile_hero_rendering.jpg": 382,
	"./assets/images/home/neighbourhood_rendering.jpg": 383,
	"./assets/images/home/team_rendering.jpg": 384,
	"./assets/images/icons/back_arrow.svg": 107,
	"./assets/images/icons/dropdown_arrow.svg": 80,
	"./assets/images/icons/dropdown_arrow_white.svg": 385,
	"./assets/images/icons/green_diagonal_line.svg": 60,
	"./assets/images/icons/grey_diagonal_line.svg": 386,
	"./assets/images/icons/hamburger_menu.svg": 286,
	"./assets/images/icons/modal_close.svg": 106,
	"./assets/images/interiors/bathroom_brown.jpg": 387,
	"./assets/images/interiors/bathroom_green.jpg": 388,
	"./assets/images/interiors/bathroom_grey.jpg": 389,
	"./assets/images/interiors/bathroom_yellow.jpg": 390,
	"./assets/images/interiors/interiors_hero.jpg": 391,
	"./assets/images/interiors/living_kitchen_brown.jpg": 392,
	"./assets/images/interiors/living_kitchen_green.jpg": 393,
	"./assets/images/interiors/living_kitchen_grey.jpg": 394,
	"./assets/images/interiors/living_kitchen_yellow.jpg": 395,
	"./assets/images/interiors/mobile_interiors_hero.jpg": 396,
	"./assets/images/loading/green_overlay_left.svg": 688,
	"./assets/images/loading/green_overlay_right.svg": 689,
	"./assets/images/loading/left.png": 283,
	"./assets/images/loading/loading_a.svg": 284,
	"./assets/images/loading/right.png": 285,
	"./assets/images/logo.svg": 690,
	"./assets/images/logo/ascent-logo-black.svg": 288,
	"./assets/images/logo/ascent-logo-white.png": 691,
	"./assets/images/logo/ascent-logo-white.svg": 293,
	"./assets/images/logo/ascent_logo.svg": 289,
	"./assets/images/logo/developer_logo.svg": 294,
	"./assets/images/logo/maple-leaf-homes-black.png": 692,
	"./assets/images/logo/maple-leaf-homes-logo.png": 693,
	"./assets/images/logo/maple-leaf-homes-logo.svg": 694,
	"./assets/images/logo/marketing-by-rennie-blk.png": 695,
	"./assets/images/logo/marketing_logo.svg": 295,
	"./assets/images/logo/marketingbyrennie.png": 696,
	"./assets/images/logo/marketingbyrennie.svg": 397,
	"./assets/images/neighbourhood/card_medtech_icon.svg": 398,
	"./assets/images/neighbourhood/card_people_icon.svg": 399,
	"./assets/images/neighbourhood/card_size_icon.svg": 400,
	"./assets/images/neighbourhood/hero_rendering.jpg": 401,
	"./assets/images/neighbourhood/map_base.png": 402,
	"./assets/images/neighbourhood/map_base_withPOI.jpg": 403,
	"./assets/images/neighbourhood/map_convenience.jpg": 404,
	"./assets/images/neighbourhood/map_education.jpg": 405,
	"./assets/images/neighbourhood/map_menu_dropdown_arrow.svg": 406,
	"./assets/images/neighbourhood/map_park_recreation.jpg": 407,
	"./assets/images/neighbourhood/map_restaurants.jpg": 408,
	"./assets/images/neighbourhood/mobile_hero_rendering.jpg": 409,
	"./assets/images/neighbourhood/poi_convenience.svg": 697,
	"./assets/images/neighbourhood/poi_education.svg": 698,
	"./assets/images/neighbourhood/poi_parks.svg": 699,
	"./assets/images/neighbourhood/poi_restaurants.svg": 700,
	"./assets/images/neighbourhood/zoom-in.svg": 410,
	"./assets/images/register_now_shape.svg": 411,
	"./assets/images/team/DA_architects_logo.svg": 412,
	"./assets/images/team/ascent_horizon_rendering.jpg": 413,
	"./assets/images/team/ascent_horizon_rendering_mobile.jpg": 414,
	"./assets/images/team/ascent_team_rendering.jpg": 415,
	"./assets/images/team/collaborative_design_studio_logo.svg": 416,
	"./assets/images/team/delta_gardens.jpg": 417,
	"./assets/images/team/delta_rise.jpg": 418,
	"./assets/images/team/delta_rise_indicator.svg": 419,
	"./assets/images/team/maple-leaf-homes-logo.svg": 420,
	"./assets/images/team/mount_waddington.jpg": 701,
	"./assets/images/team/north_delta_centre_for_the_arts.jpg": 421,
	"./assets/images/team/rennie.svg": 702,
	"./assets/images/views/compass/Compass_base.png": 703,
	"./assets/images/views/compass/Compass_base.svg": 422,
	"./assets/images/views/compass/Compass_direction.png": 704,
	"./assets/images/views/compass/Compass_direction.svg": 423,
	"./assets/images/views/level_03-04.jpg": 424,
	"./assets/images/views/level_05-06.jpg": 425,
	"./assets/images/views/level_07-08.jpg": 426,
	"./assets/images/views/level_09-10.jpg": 427,
	"./assets/images/views/level_11-12.jpg": 428,
	"./assets/images/views/level_13-14.jpg": 429,
	"./assets/images/views/level_15-16.jpg": 430,
	"./assets/images/views/level_17-18.jpg": 431,
	"./assets/images/views/level_19-20.jpg": 432,
	"./assets/images/views/level_21-22.jpg": 433,
	"./assets/images/views/level_23-24.jpg": 434,
	"./assets/images/views/level_25-26.jpg": 435,
	"./assets/images/views/level_27-28.jpg": 436,
	"./assets/images/views/level_29-30.jpg": 437,
	"./assets/images/views/level_31.jpg": 438,
	"./assets/images/views/select_level_dropdown_arrow.svg": 705,
	"./components/Button": 24,
	"./components/Button.js": 24,
	"./components/Counter": 439,
	"./components/Counter.js": 439,
	"./components/Footer/Footer": 128,
	"./components/Footer/Footer.js": 128,
	"./components/Footer/elements/CTA": 129,
	"./components/Footer/elements/CTA.js": 129,
	"./components/Footer/elements/Info": 130,
	"./components/Footer/elements/Info.js": 130,
	"./components/Header/Header": 124,
	"./components/Header/Header.js": 124,
	"./components/Header/elements/Hamburger": 125,
	"./components/Header/elements/Hamburger.js": 125,
	"./components/Header/elements/Menu": 126,
	"./components/Header/elements/Menu.js": 126,
	"./components/Header/elements/Register": 68,
	"./components/Header/elements/Register.js": 68,
	"./components/Heading": 33,
	"./components/Heading.js": 33,
	"./components/Hero": 37,
	"./components/Hero.js": 37,
	"./components/Intl": 440,
	"./components/Intl.js": 440,
	"./components/Layout/Intro": 38,
	"./components/Layout/Intro.js": 38,
	"./components/LoadAnimation": 122,
	"./components/LoadAnimation.js": 122,
	"./components/StickyBox": 131,
	"./components/StickyBox.js": 131,
	"./components/View360": 132,
	"./components/View360.js": 132,
	"./components/hooks/useScrollDown": 67,
	"./components/hooks/useScrollDown.js": 67,
	"./config/app.conf": 8,
	"./config/app.conf.js": 8,
	"./config/locales/en": 91,
	"./config/locales/en.js": 91,
	"./config/locales/zh": 92,
	"./config/locales/zh.js": 92,
	"./data/amenities": 51,
	"./data/amenities.js": 51,
	"./data/amenitiesContent": 133,
	"./data/amenitiesContent.js": 133,
	"./data/floorplans/building": 69,
	"./data/floorplans/building.js": 69,
	"./data/floorplans/filters": 52,
	"./data/floorplans/filters.js": 52,
	"./data/floorplans/floorplans": 25,
	"./data/floorplans/floorplans.js": 25,
	"./data/floorplans/levels": 43,
	"./data/floorplans/levels.js": 43,
	"./data/floorplates": 63,
	"./data/floorplates/": 63,
	"./data/floorplates/index": 63,
	"./data/floorplates/index.js": 63,
	"./data/floorplates/level1-2": 134,
	"./data/floorplates/level1-2.js": 134,
	"./data/floorplates/level20-29": 138,
	"./data/floorplates/level20-29.js": 138,
	"./data/floorplates/level3-6": 135,
	"./data/floorplates/level3-6.js": 135,
	"./data/floorplates/level30": 139,
	"./data/floorplates/level30.js": 139,
	"./data/floorplates/level31": 140,
	"./data/floorplates/level31.js": 140,
	"./data/floorplates/level7": 136,
	"./data/floorplates/level7.js": 136,
	"./data/floorplates/level8-19": 137,
	"./data/floorplates/level8-19.js": 137,
	"./data/interiors": 70,
	"./data/interiors.js": 70,
	"./data/map": 83,
	"./data/map.js": 83,
	"./data/menu": 127,
	"./data/menu.js": 127,
	"./data/stats": 141,
	"./data/stats.js": 141,
	"./data/team": 71,
	"./data/team.js": 71,
	"./index": 89,
	"./index.js": 89,
	"./pages/Amenities/Amenities": 441,
	"./pages/Amenities/Amenities.js": 441,
	"./pages/Amenities/elements/ContentBlock": 145,
	"./pages/Amenities/elements/ContentBlock.js": 145,
	"./pages/Amenities/elements/Dollhouse": 144,
	"./pages/Amenities/elements/Dollhouse.js": 144,
	"./pages/Amenities/elements/Gallery": 146,
	"./pages/Amenities/elements/Gallery.js": 146,
	"./pages/Amenities/elements/Select": 143,
	"./pages/Amenities/elements/Select.js": 143,
	"./pages/Amenities/sections/Callouts": 142,
	"./pages/Amenities/sections/Callouts.js": 142,
	"./pages/Contact/Contact": 445,
	"./pages/Contact/Contact.js": 445,
	"./pages/Floorplans/Floorplans": 446,
	"./pages/Floorplans/Floorplans.js": 446,
	"./pages/Floorplans/SinglePlan": 447,
	"./pages/Floorplans/SinglePlan.js": 447,
	"./pages/Floorplans/elements/Building": 152,
	"./pages/Floorplans/elements/Building.js": 152,
	"./pages/Floorplans/elements/Compass": 154,
	"./pages/Floorplans/elements/Compass.js": 154,
	"./pages/Floorplans/elements/DropdownFilter": 149,
	"./pages/Floorplans/elements/DropdownFilter.js": 149,
	"./pages/Floorplans/elements/Filter": 148,
	"./pages/Floorplans/elements/Filter.js": 148,
	"./pages/Floorplans/elements/Floorplate": 151,
	"./pages/Floorplans/elements/Floorplate.js": 151,
	"./pages/Floorplans/elements/Tabs": 147,
	"./pages/Floorplans/elements/Tabs.js": 147,
	"./pages/Floorplans/elements/Views": 448,
	"./pages/Floorplans/elements/Views.js": 448,
	"./pages/Floorplans/sections/ExploreByLevel": 150,
	"./pages/Floorplans/sections/ExploreByLevel.js": 150,
	"./pages/Floorplans/sections/ExploreByType": 153,
	"./pages/Floorplans/sections/ExploreByType.js": 153,
	"./pages/Home/Home": 449,
	"./pages/Home/Home.js": 449,
	"./pages/Home/elements/ContentBlock": 53,
	"./pages/Home/elements/ContentBlock.js": 53,
	"./pages/Interiors/Interiors": 450,
	"./pages/Interiors/Interiors.js": 450,
	"./pages/Interiors/elements/Scheme": 84,
	"./pages/Interiors/elements/Scheme.js": 84,
	"./pages/Interiors/sections/Features": 155,
	"./pages/Interiors/sections/Features.js": 155,
	"./pages/Neighbourhood/Neighbourhood": 451,
	"./pages/Neighbourhood/Neighbourhood.js": 451,
	"./pages/Neighbourhood/elements/Category": 160,
	"./pages/Neighbourhood/elements/Category.js": 160,
	"./pages/Neighbourhood/elements/Map": 159,
	"./pages/Neighbourhood/elements/Map.js": 159,
	"./pages/Neighbourhood/elements/StatCard": 157,
	"./pages/Neighbourhood/elements/StatCard.js": 157,
	"./pages/Neighbourhood/sections/Location": 158,
	"./pages/Neighbourhood/sections/Location.js": 158,
	"./pages/Neighbourhood/sections/Stats": 156,
	"./pages/Neighbourhood/sections/Stats.js": 156,
	"./pages/NotFound": 452,
	"./pages/NotFound.js": 452,
	"./pages/Register/Register": 453,
	"./pages/Register/Register.js": 453,
	"./pages/Register/elements/Form": 161,
	"./pages/Register/elements/Form.js": 161,
	"./pages/Register/elements/Input": 44,
	"./pages/Register/elements/Input.js": 44,
	"./pages/Register/elements/Radio": 162,
	"./pages/Register/elements/Radio.js": 162,
	"./pages/Register/elements/Select": 85,
	"./pages/Register/elements/Select.js": 85,
	"./pages/Reroute": 454,
	"./pages/Reroute.js": 454,
	"./pages/Team/Team": 455,
	"./pages/Team/Team.js": 455,
	"./pages/Team/sections/Grid": 164,
	"./pages/Team/sections/Grid.js": 164,
	"./pages/Team/sections/Intro": 163,
	"./pages/Team/sections/Intro.js": 163,
	"./pages/ThankYou": 456,
	"./pages/ThankYou.js": 456,
	"./plugins/Analytics/Analytics": 116,
	"./plugins/Analytics/Analytics.js": 116,
	"./plugins/Analytics/elements/GTM": 118,
	"./plugins/Analytics/elements/GTM.js": 118,
	"./plugins/Analytics/elements/GTag": 117,
	"./plugins/Analytics/elements/GTag.js": 117,
	"./plugins/Analytics/elements/Hotjar": 119,
	"./plugins/Analytics/elements/Hotjar.js": 119,
	"./plugins/Insight": 65,
	"./plugins/Insight.js": 65,
	"./plugins/OnUpdate": 32,
	"./plugins/OnUpdate.js": 32,
	"./plugins/SEO": 115,
	"./plugins/SEO.js": 115,
	"./plugins/language": 113,
	"./plugins/language.js": 113,
	"./plugins/prerender": 121,
	"./plugins/prerender.js": 121,
	"./plugins/scrollTop": 114,
	"./plugins/scrollTop.js": 114,
	"./plugins/sitemap-generator": 457,
	"./plugins/sitemap-generator.js": 457,
	"./redux/counter": 42,
	"./redux/counter.js": 42,
	"./redux/intl": 64,
	"./redux/intl.js": 64,
	"./redux/pageLoad": 123,
	"./redux/pageLoad.js": 123,
	"./redux/reducers": 112,
	"./redux/reducers.js": 112,
	"./redux/store": 111,
	"./redux/store.js": 111,
	"./routes": 66,
	"./routes.js": 66,
	"./styles/fonts.css": 211,
	"./styles/global": 110,
	"./styles/global.js": 110,
	"./styles/media": 4,
	"./styles/media.js": 4,
	"./styles/theme": 10,
	"./styles/theme.js": 10,
	"./styles/utils": 1,
	"./styles/utils.js": 1
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 680;